import { gql } from "@apollo/client";

export const GET_COUNTRIES = gql`
    query GetCountries {
        paises {
            id
            nombreEspanol
        }
    }
`;

export const GET_STATES = gql`
    query GetStates($countryId: Int!) {
        departamentos(paisId: $countryId) {
            id
            nombre
        }
    }
`;

export const GET_CITIES = gql`
    query GetCities($stateId: Int!) {
        ciudades(departamentoId: $stateId) {
            id
            nombre
        }
    }
`;

export const GET_CITIES_BY_COUNTRY_AND_STATE = gql`
    query GetCitiesByCountryAndState($countryCode: String!, $stateName: String!) {
        ciudadesPorPaisYDepartamento(codigoPais: $countryCode, departamento: $stateName) {
            id
            nombre
        }
    }
`;

export const GET_DISTRICTS = gql`
    query GetDistricts($cityId: Int!) {
        distritos(ciudadId: $cityId) {
            id
            nombre
        }
    }
`;
